export class DateUtils {

  /*Convert string to date only if date is valid*/
  static stringToDate(sDate: string): any {
    if (sDate != null && (sDate.length === 10 || sDate.length === 7) ) {
      const tab = sDate.split('/');
      if (tab && tab.length === 3) {
        const year: number = parseInt(tab[2], 10);
        const month: number = parseInt(tab[1], 10) - 1;
        const day: number = parseInt(tab[0], 10);
        /* Build date with year month day from string */
        const date: Date = new Date(year, month, day);
        return date;
        /* Get year month day from built date /
        const dateYear: number = date.getFullYear();
        const dateMonth: number = date.getMonth();
        const dateDay: number = date.getDate();
        /* Compare initial year month day values with the new ones extracted from built date /
        if (year === dateYear && month === dateMonth && day === dateDay) {
          return date;
        }*/
      } else if (tab && tab.length === 2) {
        const year: number = parseInt(tab[1], 10);
        const month: number = parseInt(tab[0], 10) - 1;
        //const day: number = parseInt(tab[0], 10);
        /* Build date with year month day from string */
        const date: Date = new Date(year, month, 1);
        return date;
        /* Get year month day from built date *
        const dateYear: number = date.getFullYear();
        const dateMonth: number = date.getMonth();
        const dateDay: number = date.getDate();
        /* Compare initial year month day values with the new ones extracted from built date *
        if (year === dateYear && month === dateMonth) {
          return date;
        }*/
      }
    }
    return null;
  }

  static getAge(birthDate: Date): number {
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
      }
      return age;
  }

  static formatDate(date: Date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [day, month, year].join('/');
  }

  static formatDateMDY(date: Date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [month, day, year].join('/');
  }

  static formatDateMonthYear(date: string) {
    var d = this.stringToDate(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
        
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [month, year].join('/');
  }

  static get18YearsDateBeforeToday() {
    const today = new Date();
    return this.get18YearsDateBefore(today);
  }

  static get18YearsDateBefore(today: Date) {
    var d = today;
    d.setFullYear(d.getFullYear() - 18);
    return  DateUtils.formatDateMDY(d);
  }
}



// WEBPACK FOOTER //
// ./src/app/date-utils.ts